import AccountCommunication, { statesFromAPIResponse } from './AccountCommunication';

export default AccountCommunication;
export { statesFromAPIResponse };
